import React from 'react';
import ReactDOM from 'react-dom/client';
import '@carbon/styles/css/styles.css';
import './utils/css/index.css';
import './utils/css/colorPalette.css';
import './utils/css/iconFonts.css';
import './utils/css/fonts.css';
import './utils/css/fontSize.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
// Duplicate `@carbon/styles/css/styles.css` import removed — it was already imported
// on line 3 and a second import doubled the Carbon CSS payload in the host bundle.
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import { AuthContextProvider } from './store/AuthContext';
import store from './redux/reduxAppStore';
import { Provider } from 'react-redux';
import 'react-international-phone/style.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

async function prepareApp() {
    if (process.env.REACT_APP_USE_MSW === 'true') {
        const { worker } = await import('./mocks/browser');
        await worker.start({
            onUnhandledRequest: 'bypass',
        });
    }
}

prepareApp().then(() => {
    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <AuthContextProvider>
                    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                        <App />
                    </BrowserRouter>
                </AuthContextProvider>
            </Provider>
        </React.StrictMode>
    );

    reportWebVitals();
});
